// ============================|| AUTH UTILITIES ||============================ //

/**
 * Check if user is authenticated
 * If no token exists, clear localStorage and navigate to login
 * @param {function} navigate - React Router navigate function
 * @returns {boolean} - Returns true if authenticated, false otherwise
 */
export const checkAuth = (navigate) => {
  const token = localStorage.getItem('token');

  if (!token) {
    // Clear all localStorage data
    localStorage.clear();
    localStorage.removeItem('role');
    // Navigate to login page
    navigate('/login');

    return false;
  }

  return true;
};
/**
 * Logout user - clear localStorage and navigate to login
 * @param {function} navigate - React Router navigate function
 */
export const logout = (navigate) => {
  // Clear all localStorage data
  localStorage.clear();
  localStorage.removeItem('role');
  // Navigate to login page
  navigate('/login');
};

/**
 * Get stored token from localStorage
 * @returns {string|null} - Returns token or null
 */
export const getToken = () => {
  return localStorage.getItem('token');
};

/**
 * Get stored refresh token from localStorage
 * @returns {string|null} - Returns refresh token or null
 */
export const getRefreshToken = () => {
  return localStorage.getItem('refreshToken');
};

/**
 * Get stored user data from localStorage
 * @returns {object|null} - Returns user data object or null
 */
export const getUserData = () => {
  const userData = localStorage.getItem('userData');
  return userData ? JSON.parse(userData) : null;
};

/**
 * Check if user is authenticated (without navigation)
 * @returns {boolean} - Returns true if token exists, false otherwise
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return !!token;
};
